import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './GiftCardPromoModal.scss';


export default class GiftCardPromoModal extends Component {
    static get propTypes() {
        return {
            isBuyer: PropTypes.boolean
        };
    }

    render() {
        const {isBuyer} = this.props;

        return (
            <div className="gift-card-promo modal nu-modal fade">
                <div className="nu-modal-content">
                    <div className="modal-dialog gift-card-modal-dialog">
                        <img src={global.imageBaseUrl + 'giftCardPromo.svg'}/>
                        <div className="gift-card-content">
                            <h1>Before you go...</h1>
                            <p className="offer-title">
                                <span className="offer-title-point">Get a <span className="highlight">$50 Amazon Gift Card</span></span>
                                <span className="offer-title-point">when you hire an agent through UpNest*. (Mention code OFFER50)</span>
                            </p>
                            <p className="offer-subtitle">*Offer is paid out at the close of escrow.</p>
                            <a type='submit' className='submit-button btn btn-md btn-default'
                               href={isBuyer ? 'buyer-received-quotes' : 'seller-received-quotes'}
                               onClick={() => trackEvent('Unsubscription', 'clientClickedOnSeeProposals').withGA()}>
                                See my Agents
                            </a>
                            <a className="not-link" href="javascript:void(0)" data-dismiss="modal" aria-label="Close">
                                <span>No, thanks. </span>
                                <span>I don’t want to save thousands of dollars and get a $50 Gift Card.</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
